import { useEffect } from 'react';
import Card from './Cards';
import { useTranslation } from 'react-i18next';

export default function Contact() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = `${t('common.appName')} - ${t('nav.contact')}`;
  }, [t]);

  return (
    <div>
      <Card title={t('contact.title')}>
        <p className="text-muted-foreground">
          {t('contact.body')}<br />
          {t('contact.cta')}{' '}
          <a
            href="mailto:kontakt@kalkulatorpiwowara.pl"
            className="text-primary underline-offset-4 hover:underline"
          >
            kontakt@kalkulatorpiwowara.pl
          </a>
        </p>
      </Card>
    </div>
  );
}
